import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.HeatingZone
 * The DEFA HeatingZone model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	zone: '/zone',
	heatingZone: '/heatingZone?attrs=',
};

const HeatingZone = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('unitId') + api.zone +
			   this.get('zoneNumber') + api.heatingZone + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			
			alarmMask: null,
			alarmMaskError: null,
			
			followMaster: null,
			followMasterError: null,
			
			highTempLevel: null,
			highTempLevelError: null,
			
			lowTempLevel: null,
			lowTempLevelError: null,
			
			zoneMode: null,
			zoneModeError: null,
		}),
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.onOff){
				this.parseAttribute('onOff', response.onOff, options, newModelAttributes)
			}
			
			if(response.alarmMask){
				this.parseAttribute('alarmMask', response.alarmMask, options, newModelAttributes)
			}
			
			if(response.followMaster){
				this.parseAttribute('followMaster', response.followMaster, options, newModelAttributes)
			}
			
			if(response.highTempLevel){
				this.parseAttribute('highTempLevel', response.highTempLevel, options, newModelAttributes)
			}
			
			if(response.lowTempLevel){
				this.parseAttribute('lowTempLevel', response.lowTempLevel, options, newModelAttributes)
			}
			
			if(response.zoneMode){
				this.parseAttribute('zoneMode', response.zoneMode, options, newModelAttributes)
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			this.set(newModelAttributes);
		}
	},
	
	//TODO! internalCompensation is also an attribute for this cluster, but something is wrong with it, so leaving it out from here.
	getAttributes: function() {
		return 'alarmMask,followMaster,highTempLevel,lowTempLevel,zoneMode';
	},
	
	toBackendJSON: function() {
		return {
			alarmMask : this.get('alarmMask'),
			followMaster : this.get('followMaster'),
			highTempLevel : this.get('highTempLevel'),
			lowTempLevel : this.get('lowTempLevel'),
			zoneMode : this.get('zoneMode')
		};
	},
	
	_getDependentModels: function(){
		let mode = this.get('zoneMode');
		let dependentModels = [];
		if('thermostat' === mode){
			dependentModels.push(channel.request('zoneHolders').get(this.get('unitId')).getZone(this.get('zoneNumber')).getModel('3'));
		}else if('regulator'=== mode){
			dependentModels.push(channel.request('zoneHolders').get(this.get('unitId')).getZone(this.get('zoneNumber')).getModel('4'));
		}
		// followMaster and the onOff model is dependent of each other
		dependentModels.push(channel.request('zoneHolders').get(this.get('unitId')).getZone(this.get('zoneNumber')).getModel('1'));
		
		return dependentModels;
	},
	
} );

export default HeatingZone;
